(function () {
  angular.module('MktzapApp.Controllers')
    .controller('OfficeHoursController', officeHoursController)

  officeHoursController.$inject = ['NotificationService', 'OfficeHoursService', 'FoundationApi', 'SectorService', 'LangService']

  function officeHoursController (NotificationService, OfficeHoursService, FoundationApi, SectorService, LangService) {
    var vm = this
    vm.registerCMD = {}
    vm.sectors = null
    vm.selectedSector = null
    vm.params = {}
    vm.registerCMD.id = ''
    vm.editOfficeHour = null
    vm.selectedCheckbox = []
    vm.selectedSectors = []
    vm.index = null

    LangService
      .getPageLabels({ 'page': 'menu.master.officeHours' })
      .$promise
      .then(function (data) {
        vm.labels = data.lang
      })

    loadOfficeHours()

    SectorService.sectors_with_trashed(function (data) {
      vm.sectors = data.filter(function (item) {
        if (item.deleted_at == null) {
          return true
        }

        return false
      })
    })

    vm.addSectorInSelected = function (sector) {
      if (!checkIfSectorIsInUse(sector.id)) {
        let found = vm.selectedSectors.find(element => {
          return element === sector.id
        })

        if (!found) {
          vm.selectedSectors.push(sector.id)
          return true
        }

        let index = vm.selectedSectors.indexOf(sector.id)

        if (index > -1) {
          vm.selectedSectors.splice(index, 1)
          return false
        }
      }
    }

    function checkIfSectorIsInUse (id) {
      let officeHourFounded = null
      let sectorOfficeHour = null

      vm.OfficeHoursData.forEach((value, index) => {
        officeHourFounded = value.sectors.find(function (element) {
          return element === id
        })

        if (officeHourFounded) {
          sectorOfficeHour = value
        }
      })

      if (sectorOfficeHour && typeof vm.newOfficeHour._id === 'undefined') {
        NotificationService.warningHandler(null, vm.labels.sectorAlreadyInUse)
        vm.selectedCheckbox[officeHourFounded] = false
        return true
      }

      if (
        sectorOfficeHour &&
        sectorOfficeHour._id !== vm.newOfficeHour._id
      ) {
        NotificationService.warningHandler(null, vm.labels.sectorAlreadyInUse)
        vm.selectedCheckbox[officeHourFounded] = false
        return true
      }

      return false
    }

    function fixBlankMessages (messages) {
      messages.on = messages.on ? messages.on : null
      messages.off = messages.off ? messages.off : null
      return messages
    }

    function fixMessages () {
      vm.newOfficeHour.week.messages = fixBlankMessages(vm.newOfficeHour.week.messages)
      vm.newOfficeHour.saturday.messages = fixBlankMessages(vm.newOfficeHour.saturday.messages)
      vm.newOfficeHour.sunday.messages = fixBlankMessages(vm.newOfficeHour.sunday.messages)
      vm.newOfficeHour.holiday.messages = fixBlankMessages(vm.newOfficeHour.holiday.messages)
    }

    vm.saveOfficeHour = function () {
      fixMessages()

      if (vm.newOfficeHour.holiday.date) {
        vm.newOfficeHour.holiday.date = formatStringData(vm.newOfficeHour.holiday.date, '/', '-')
      }

      if (!vm.newOfficeHour.week.start || !vm.newOfficeHour.week.end ||
        !vm.newOfficeHour.saturday.start || !vm.newOfficeHour.saturday.end ||
        !vm.newOfficeHour.sunday.start || !vm.newOfficeHour.sunday.end
      ) {
        NotificationService.warningHandler(null, vm.labels.fillObligatedPeriods)
        return;
      }

      if (!validatePeriods()) {
        NotificationService.warningHandler(null, vm.labels.incorrectHour)
        return;
      }

      if (vm.selectedSectors.length > 0) {
        vm.newOfficeHour.sectors = vm.selectedSectors

        getStorageRequest()
          .$promise
          .then(function (data) {
            NotificationService.successHandler(null, vm.labels.requestProcessed)
            updateList(data)
          })
          .catch(function (data) {
            NotificationService.errorHandler(null, vm.labels.requestError)
          })
        FoundationApi.publish('addNumberModal', 'close')
      } else {
        NotificationService.warningHandler(null, vm.labels.selectSector)
      }
    }

    function updateList (data) {
      if (typeof vm.newOfficeHour._id === 'undefined') {
        vm.OfficeHoursData.push(data)
      } else {
        vm.OfficeHoursData.forEach((value, key) => {
          if (value._id === vm.newOfficeHour._id) {
            vm.OfficeHoursData[key] = vm.newOfficeHour
          }
        })
      }
    }

    function getStorageRequest () {
      if (typeof vm.newOfficeHour._id !== 'undefined') {
        return OfficeHoursService.update(vm.newOfficeHour)
      }

      return OfficeHoursService.save(vm.newOfficeHour)
    }

    function loadOfficeHours () {
      OfficeHoursService
        .all()
        .$promise
        .then(function (data) {
          vm.OfficeHoursData = fixOfficeHoursInformation(data)
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, vm.labels.errorToLoadOfficeHours)
        })
    }

    function fixOfficeHoursInformation (officeHours) {
      officeHours.forEach(function (item, index) {
        if (officeHours[index].holiday.date) {
          officeHours[index].holiday.date = formatStringData(officeHours[index].holiday.date, '-', '/')
        }
      })

      return officeHours
    }

    vm.deleteOfficeHourModal = function (officeHour, index) {
      vm.newOfficeHour = officeHour
      vm.index = index
      FoundationApi.publish('deleteOfficeHourModal', 'open')
    }

    vm.addOfficeHourModal = function () {
      vm.newOfficeHour = cleanFields()
      FoundationApi.publish('addNumberModal', 'open')
    }

    vm.editofficeHour = function (officeHour) {
      vm.newOfficeHour = officeHour
      vm.selectedSectors = officeHour.sectors
      populateSelectedCheckbox()
      FoundationApi.publish('addNumberModal', 'open')
    }

    function populateSelectedCheckbox () {
      vm.sectors.forEach((item) => {
        vm.selectedCheckbox[item.id] = vm.checkIsChecked(item.id)
      })
    }

    vm.checkIsChecked = function (id) {
      let found = vm.selectedSectors.find(element => {
        return element === id
      })

      if (found) {
        return true
      }

      return false
    }

    vm.deleteOfficeHour = function (officeHour, index) {
      OfficeHoursService
        .delete({
          id: officeHour._id
        })
        .$promise
        .then(function (data) {
          vm.OfficeHoursData.splice(index, 1)
          NotificationService.successHandler(null, vm.labels.officeHoursDeleted)
        })
        .catch(function (data) {
          NotificationService.successHandler(null, vm.labels.requestError)
        })

      FoundationApi.publish('deleteOfficeHourModal', 'close')
    }

    function formatStringData (date, separator, newSeparator) {
      return date.split(separator).reverse().join(newSeparator)
    }

    function validatePeriods () {
      week = validateHours(vm.newOfficeHour.week)
      saturday = validateHours(vm.newOfficeHour.saturday)
      sunday = validateHours(vm.newOfficeHour.sunday)
      holiday = validateHours(vm.newOfficeHour.holiday)

      if (week && saturday && sunday && holiday) {
        return true
      }

      return false
    }

    function validateHours (period) {
      let isValid = true
      if (period.start && period.end) {
        let periods = []
        periods[0] = period.start.split(':')
        periods[1] = period.end.split(':')

        periods.forEach(element => {
          if (!(element.length == 2 && element[0].length == 2 && element[1].length == 2)) {
            isValid = false
            return isValid
          }
        })
        return isValid
      }

      if (period.start || period.end) {
        isValid = false
      }

      return isValid
    }

    function cleanFields () {
      vm.selectedCheckbox = []
      vm.selectedSectors = []

      return {
        name: null,
        company_id: null,
        sectors: null,
        week: {
          start: null,
          end: null,
          messages: {
            on: null,
            off: null
          }
        },
        saturday: {
          start: null,
          end: null,
          messages: {
            on: null,
            off: null
          }
        },
        sunday: {
          start: null,
          end: null,
          messages: {
            on: null,
            off: null
          }
        },
        holiday: {
          date: null,
          start: null,
          end: null,
          messages: {
            on: null,
            off: null
          }
        }
      }
    }
  }
})();
